function jsLoader() {
  return new Promise((resolve, reject) => {
    dsf.http
      .importFiles([
        dsf.url.getWebPath("$/js/libs/esprima/esprima.browser.min.js"),
        dsf.url.getWebPath("$/js/libs/esprima/estraverse.browser.min.js"),
        dsf.url.getWebPath("$/js/libs/esprima/escodegen.browser.min.js")
      ])
      .then(() => {
        resolve();
      })
      .catch((ex) => {
        reject(ex);
      });
  });
}

const javascript = function () {
  return jsLoader().then(() => {
    return {
      esprima,
      estraverse,
      escodegen
    };
  });
};


export default {
  javascript
};
